<template>
  <div class="pb-3">
    <div class="border-bottom" v-if="isUserRoot && listForRootAsUserMode"> Viewing User LCR from Root</div>

    <div class="row pl-3 pr-3 mt-3">
      <div class="col-12 col-md-6">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search for destination / Japan"></dg-text-field>
      </div>
      <div class="col-12 col-md-6">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
      <!--<el-col :class="$langConfig.cssClass" class="ml-3" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :field_span="20"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark="required"
            label="Division"
            name="division_id"
            rules="required"></dg-select-field>
      </el-col>-->
    </div>


    <!--<el-row class="text-center  ml-2" type="flex">
      <el-col class="border-left border-top border-right" style="width: 155px"></el-col>
      <span :key="levelKey" v-for="(level, levelKey) in levelsConfig">
        <el-col :style="'width: ' + rateCellWidth + ';background-color: ' + levelsConfig[levelKey].background + ';width: 60px'"
                class="border-top border-right text-dark"> L{{ levelKey + 1 }}
        </el-col>
        <el-col :style="'width: ' + prefixCellWidth"
                class="border-top border-right text-dark"> Test
        </el-col>
        <el-col :style="'width: ' + timeCellWidth"
                class="border-top border-right text-dark" v-if="!isUserCustomerOrReseller"> <i class="el-icon-view"></i>
        </el-col>
      </span>
    </el-row>-->

    <el-row class="text-center ml-2" type="flex" v-show="amReady">
      <!--<el-col class="border table-header-cell table-top-destination-cell">Top</el-col>-->
      <el-col class="border table-header-destination" :style="'width: ' + destinationCellWidth">Destination <br> Billing Cycle</el-col>

      <span :key="levelKey" v-for="(level, levelKey) in levelsConfig">
          <el-col class="border table-header-cell" :style="'justify-content: center;width: ' + rateCellWidth">Rate</el-col>
          <el-col class="border table-header-cell" :style="'width: ' + prefixCellWidth"> Prefix</el-col>
          <el-col class="border table-header-cell table-time-status-cell" :style="'width: ' + timeCellWidth" v-if="!isUserCustomerOrReseller">Status</el-col>
        </span>
    </el-row>
    <el-row :key="destKey" class="text-center ml-2 custom-row" type="flex" v-for="(des, destKey) in destinations" v-show="amReady">

      <!-- <el-col class="border border-top-0 table-cell table-top-destination-cell">
         <topDestinationCheckbox :checked="des.data.is_top" :destinationId="des.data.id"
                                 :onUpdate="topDestinationChanged"></topDestinationCheckbox>
       </el-col>-->

<!--      <el-col class="border-right border-bottom table-cell table-destination-cell" :class="getDestinationClass(des.data.label)" :key="destKey">-->
      <el-col class="border-right border-bottom table-cell" :style="'width: ' + destinationCellWidth" :class="getDestinationClass(des.data.label)" :key="destKey">
        <div :title="des.data.label">{{String(des.data.label).slice(0, 22) }} / {{des.data.billing_cycle}}</div>
      </el-col>

      <span :key="rateKey" v-for="(rate, rateKey) in des.rates">
          <el-col :style="'justify-content: center;width: ' + rateCellWidth + ';background-color:' + levelsDataConfig[rateKey].background"
                  class="border-right border-bottom table-cell"  :class="usedDestinations['currentDestinationClass']">
           {{ rate.rate }}
          </el-col>

          <el-col :style="'width: ' + prefixCellWidth + ';background-color:' + levelsDataConfig[rateKey].background" :class="usedDestinations['currentDestinationClass']"
                  class="border-right border-bottom table-two-line-data-cell">
            <vendorPrefixCall :callIsOnGoingFunc="callIsOnGoingFunc" :destKey="destKey" :destinationId=" (isUserCustomerOrReseller) ? rate.dialcode : des.data.id" @refreshTable="refreshTable"
                              :prefix="rate.prefix" :rateId="rate.id" :rateKey="rateKey"
                              :vendor="rate.vendor"
            ></vendorPrefixCall>
          </el-col>

          <el-col :style="'width: ' + timeCellWidth + ';background-color:' + levelsDataConfig[rateKey].background"
                  class="border-right border-bottom table-time-status-cell" v-if="!isUserCustomerOrReseller">
            <timeStatus style="background: transparent"
                :afterSettingNewStatus="afterSettingNewStatus" :broadcastId="rate.broadcastId"
                        :broadcastPublicId="rate.broadcastPublicId"
                        :destKey="destKey"
                        :rateKey="rateKey"
                        :status="rate.call_test_status_id"
                        :time="rate.last_test"></timeStatus>
          </el-col>
        </span>
    </el-row>
  </div>
</template>

<script>
import module from '@/modules/voip-lcr-top-destinations/index'
import {notify} from '@/system-services/notify.js'

import panelMixin from "@/app/portals/cpanel/mixins/util";

export default {
  mixins: [panelMixin],
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    /*topDestinationCheckbox: () => import('@/modules/voip-lcr-top-destinations/lcr/table-components/TopDestinationCheckbox'),*/
    vendorPrefixCall: () => import('@/modules/voip-lcr-top-destinations/lcr/table-components/VendorPrefixCall'),
    timeStatus: () => import('@/modules/voip-lcr-top-destinations/lcr/table-components/TimeStatus'),
  },
  props: {
    listForRootAsUserMode: {
      default: false
    },
    requested_user_id: {
      default: false
    },
    requested_user_profile: {
      default: false
    },
    defaultDivision: {
      required: true,
    }
  },
  data() {
    return {
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserCustomerOrReseller: $store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller'],
      usedDestinations: Object.seal({
        currentDestinationClass: 'destinationIsEven',
        lastDestination: null
      }),
      divisionId: null,
      divisionsList: [],
      userSearchTimeOut: null,
      maxLevels: 4,
      levelsConfig: [
        {
          background: '#ff7373'
        },
        {
          background: '#fab58b'
        },
        {
          background: '#93ffc4'
        },
        {
          background: '#cb93ff'
        },/*
        {
          background: '#ff7373'
        },
        {
          background: '#fab58b'
        }*/
      ],
      levelsDataConfig: [
        {
          background: ''
        },
        {
          background: ''
        },
        {
          background: ''
        },
        {
          background: ''
        },
        {
          background: ''
        },
        {
          background: ''
        },
        {
          background: ''
        }
      ],
      destinations: [],
      amReady: false,
      module: {
        ...module
      },
      userSearch: '',
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      rateCellWidth: 0,
      timeCellWidth: 0,
      prefixCellWidth: 0,
      destinationCellWidth: 0,
      interval: null
    };
  },
  mounted() {
    setTimeout( () => {
      this.calcCellWidth()
    }, 1000)
    /*this.interval = setInterval( () => {
      this.calcCellWidth()
    }, 6000)*/
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  beforeMount() {
    this.panelMixin_getUserVoipDivision('divisionsList', () => {})
    this.divisionUpdated()
  },
  methods: {
    calcCellWidth() {
      let maxWidth = this.$el.offsetWidth;
      this.amReady = false
      let rateCellWidth = 60
      let timeCellWidth = 65
      let destinationWidth = 155
      let fixedPadding = 21

      let rateCellMaxWidth = rateCellWidth * this.maxLevels
      let timeCellMaxWidth = timeCellWidth * this.maxLevels

      let tempNum = rateCellMaxWidth + fixedPadding + destinationWidth
      if (!this.isUserCustomerOrReseller) {
        tempNum = tempNum + timeCellMaxWidth
      }


      let prefixCellWidth = ((maxWidth - (tempNum) ) / this.maxLevels)
      this.rateCellWidth = rateCellWidth + 'px'
      this.timeCellWidth = timeCellWidth + 'px'
      this.prefixCellWidth = prefixCellWidth + 'px'
      this.destinationCellWidth = destinationWidth + 'px'
      this.amReady = true
    },
    refreshTable () {
      this.navigateToPage(this.currentPage)
    },
    getDestinationClass (label) {
      /*let l = label.replace(/,/g, ' ').split(' ')[0]
      if (l != this.usedDestinations['lastDestination']) {
        this.usedDestinations['lastDestination'] = l
        this.toggelDestinationClass()
      }*/
      this.toggelDestinationClass()
      return this.usedDestinations['currentDestinationClass']
    },
    toggelDestinationClass () {
      if (this.usedDestinations['currentDestinationClass'] == 'destinationIsOdd') {
        this.usedDestinations['currentDestinationClass'] = 'destinationIsEven'
      } else {
        this.usedDestinations['currentDestinationClass'] = 'destinationIsOdd'
      }
    },
    getLcrData (page) {
      if (this.listForRootAsUserMode) {
        this.listForRootAsUser({page: page, search: this.userSearch, division_id: this.divisionId, requested_user_id: this.requested_user_id, requested_user_profile: this.requested_user_profile}).then(response => {
          this.buildLCRTableData(response)
        })
      } else {
        this.getEntityList({page: page, search: this.userSearch, division_id: this.divisionId}).then(response => {
          this.buildLCRTableData(response)
        })
      }

      this.currentPage = page;
    },
    divisionUpdated(inputField) {
      this.divisionId = this.defaultDivision
      this.getLcrData(1)
    },
    buildLCRTableData(response) {
      let destinations = response.rows
      for (let dest in destinations) {
        let rates = destinations[dest].rates
        while (rates.length < this.maxLevels) {
          rates.push({})
        }
      }
      this.destinations = destinations;
      this.sortRates()
      this.recordsCounter = response.count;
    },
    sortRates () {
      let rates = null
      let compareFunc = function compare( a, b ) {
        if ( a.rate < b.rate ){
          return -1;
        }
        if ( a.rate > b.rate ){
          return 1;
        }
        return 0;
      }

      for(let des in this.destinations) {
        this.destinations[des].rates.sort(compareFunc);
      }
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getLcrData(1)
        //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    afterSettingNewStatus(destKey, rateKey, newStatus) {
      /*let rate = this.destinations[destKey]['rates'][rateKey]
      rate.call_test_status_id = newStatus*/
      let statusToAvoid = [3, 4, 6]
      if (statusToAvoid.indexOf(newStatus) != -1 ) {
        this.getLcrData(this.currentPage)
      }
    },
    callIsOnGoingFunc(destKey, rateKey, dataMessage) {
      let rate = this.destinations[destKey]['rates'][rateKey]

      if (dataMessage) {
        rate.last_test = 'Now'
        rate.call_test_status_id = 1
        rate.broadcastId = dataMessage.data.id
        rate.broadcastPublicId = dataMessage.data.public_id
      }
    },
    topDestinationChanged(params) {
      let verb = (params.checked) ? 'post' : 'delete'
      this.topDestination({destinationId: params.destination_id, verb}), then((r) => {
      })
    },
    ...$mapActions('voip-lcr-top-destinations-api', {getEntityList: 'listTopDestinations', listForRootAsUser : 'listForRootAsUser'}),
    ...$mapActions('voip-destination-api', {topDestination: 'topDestination'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getLcrData(page)
      // $router.push({name: 'module->voip-lcr-top-destinations->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-lcr-top-destinations->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>

<style scoped>
.table-top-destination-cell {
  width: 60px;
}

.table-destination-cell {
  width: 155px;
}

.table-vendor-prefix-cell {
  width: 100px;
}

.table-header-destination {
  text-align:left;
  justify-content: left;
  padding-left: 5px;
  height: 50px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-family: Consolas;
  text-transform: uppercase;
  color: #1b1e21;
}

.table-time-status-cell {
  height: 50px;
  font-size: 12px;
  vertical-align: middle;
  padding: 0;
  text-transform: uppercase;
  color: #1b1e21;
}


.table-header-one-word-cell {
  height: 50px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  /*justify-content: center;*/
  padding-left: 5px;
  align-items: center;
}

.table-header-cell {
  height: 50px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Consolas;
  text-transform: uppercase;
  color: #1b1e21;
}

.table-cell {
  height: 50px;
  font-size: 11px;
  display: flex;
  /*justify-content: center;*/
  padding-left: 5px;
  align-items: center;
}

.table-two-line-data-cell {
  height: 50px;
  font-size: 12px;;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-row:hover {
  background: #dadada;
}

.destinationIsOdd {
  background: rgba(172, 168, 202, 0.2) !important;
}

.destinationIsEven {
  background: transparent;
}
</style>
